import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CheckmarkIconComponent} from './checkmark-icon/checkmark-icon.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [CheckmarkIconComponent],
  exports: [CheckmarkIconComponent],
  providers: []
})
export class CustomIconsModule {
}
